import torture from "../images/torture.jpeg";
import torture2 from "../images/torture2.jpeg";
const tortureArray = () => {
  return [torture, torture2];
};

export default tortureArray();
